import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { postDeviceVideoSettings } from '../../services/VideoService';
import { DeviceVideoSettingsPayload, DeviceVideoSettingsResponse } from '../../types/Videos';

type Result = UseMutationResult<DeviceVideoSettingsResponse, Error, DeviceVideoSettingsPayload>;

function usePostDeviceVideoSettings(successCb: () => void, failureCb: (error: string) => void): Result {
  const queryClient = useQueryClient();

  return useMutation(postDeviceVideoSettings, {
    onSuccess: () => {
      successCb();
      // queryClient.invalidateQueries({ queryKey: ['device-video-settings'] });
    },
    onError: (error: Error) => {
      failureCb(error.message);
    },
  });
}

export default usePostDeviceVideoSettings;
